module.exports = __webpack_public_path__ + "img/00—01—Login—IBplus.39856bec.jpg";